export const RECAPTCHA_CONTEXT = {
    FAILED_VALIDATION: "Recaptcha Validation Failed",
    FAILED_CHECK: "Recaptcha Check Failed",
};
